import React from "react";
import { Grid, GridProps, TextField } from "@material-ui/core";

// prop types
interface GridTextFieldProps {
    disabled?: boolean,
    error?: boolean,
    helperText?: string,
    label: string,
    maxLength?: number,
    multiline?: boolean,
    placeholder?: string,
    size: GridProps["xs"],
    type?: string,
    value: string,
    xsSize?: GridProps["xs"],
    onChange?: (value: string) => void,
}

// grid text field
const GridTextField = ({ disabled, error, helperText, label, maxLength, multiline, placeholder, size, type, value, xsSize, onChange }: GridTextFieldProps) => (
    <Grid item xs={xsSize || size} sm={size}>
        <TextField
            disabled={disabled}
            error={error}
            fullWidth
            helperText={helperText}
            inputProps={{ maxLength }}
            label={label}
            multiline={multiline}
            placeholder={placeholder}
            type={type}
            value={value}
            variant="outlined"
            onChange={(e) => onChange && onChange(e.target.value)}
        />
    </Grid>
);

export default GridTextField;
